import { render } from "./CompetitionStageCalendar.vue?vue&type=template&id=5705d5d5&scoped=true"
import script from "./CompetitionStageCalendar.vue?vue&type=script&lang=js"
export * from "./CompetitionStageCalendar.vue?vue&type=script&lang=js"

import "./CompetitionStageCalendar.vue?vue&type=style&index=0&id=5705d5d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5705d5d5"]])

export default __exports__